/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-09-08 18:03:53
 * @LastEditors: Li Yong
 * @LastEditTime: 2023-03-05 08:17:50
 */
import authUtils from '@/plugins/auth';

const checkAuth = function (cb, auth) {
	return function (...arg) {
		// vue对于已加载组件的method会作缓存处理，所以只能在返回的函数里做权限拦截
		if (!authUtils.hasPermi(auth)) {
			return;
		}
		cb.apply(this, arg);
	};
};

export default {
	checkAuth,
};
